<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagement}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <wList v-model="dataForm.companyId" placeholder="公司名称"></wList>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="dataForm.reviewersStatus"
            clearable
            placeholder="状态"
          >
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button
            v-if="$hasPermission('sys:accessmanagement:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >{{ $t("add") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          prop="companyName"
          label="公司名称"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="windCity"
          label=" 准入城市"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column width="300px" label="准入材料" header-align="center">
          <template slot-scope="scope">
            <div class="p-box">
              <p
                v-if="scope.row.windCooperationAgreements"
                @click="look(scope.row.windCooperationAgreements)"
              >
                签约主体与持牌金融机构（或银行）贷款产品合作协议
              </p>
              <p
                v-if="scope.row.windContracts"
                @click="look(scope.row.windContracts)"
              >
                签约主体与借款人的贷款委托服务合同
              </p>
              <p
                v-if="scope.row.windLicence"
                @click="look(scope.row.windLicence)"
              >
                签约主体的营业执照（加盖公章）
              </p>
              <p
                v-if="scope.row.windLegalId"
                @click="look(scope.row.windLegalId)"
              >
                签约主体的法人身份证复印件
              </p>
              <p
                v-if="scope.row.windOfficeAddress"
                @click="look(scope.row.windOfficeAddress)"
              >
                办公地址的房屋租赁合同
              </p>
              <p
                v-if="scope.row.reviewersStatus"
                @click="look(scope.row.reviewersStatus)"
              >
                真实签约现场视频
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="200px" label="合同" header-align="center">
          <template slot-scope="scope">
            <div class="p-box">
              <p
                v-if="scope.row.contractsBrandAffiliation"
                @click="look(scope.row.contractsBrandAffiliation)"
              >
                品牌加盟协议
              </p>
              <p
                v-if="scope.row.contractsBrandUse"
                @click="look(scope.row.contractsBrandUse)"
              >
                品牌使用协议
              </p>
              <p
                v-if="scope.row.contractsTechnicalServices"
                @click="look(scope.row.contractsTechnicalServices)"
              >
                技术服务协议
              </p>
              <p
                v-if="scope.row.contractsComplianceCommitment"
                @click="look(scope.row.contractsComplianceCommitment)"
              >
                合规承诺涵
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="doorwayPhoto"
          label="门头照"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="p-box" v-if="scope.row.doorwayPhoto">
              <p @click="look(scope.row.doorwayPhoto)">
                祁浩品牌加盟商易拉宝一块并放置于门头照片
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="windCompanyProfile"
          label="公司介绍"
          header-align="center"
          align="center"
          width="200px"
          
        >
        <template slot-scope="scope">
            <el-tooltip  placement="top" class="tooltip">
              <div slot="content" class="content">{{ scope.row.windCompanyProfile }}</div>
              <p class="showOverTooltip">{{ scope.row.windCompanyProfile }}</p>
            </el-tooltip>
          </template>
         

       
        </el-table-column>
        <el-table-column 
          prop="mobile"
          label="手机号"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="reviewersStatus"
          label="状态"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.reviewersStatus == 0">待审核</span>
              <span v-if="scope.row.reviewersStatus == 1">审核通过</span>
              <span v-if="scope.row.reviewersStatus == 2">待修改</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="status"
          label="是否有效"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.status == 0">无效</span>
              <span v-if="scope.row.status == 1">有效</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="applicationPeriod"
          label="申请时间"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="updateTime"
          label="修改时间"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="applicationPeriod"
          label="准入时间"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="applicant"
          label="申请人"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="reviewersName"
          label="审批人"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          :label="$t('handle')"
          fixed="right"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              v-if="
                scope.row.reviewersStatus == 0 &&
                $hasPermission('sys:accessmanagement:audit')
              "
              type="text"
              size="small"
              @click="editStatus(scope.row, '/sys/accessmanagement/audit', 1)"
              >通过</el-button
            >
            <el-button
              v-if="
                scope.row.reviewersStatus == 0 &&
                $hasPermission('sys:accessmanagement:audit')
              "
              type="text"
              size="small"
              @click="editStatus(scope.row, '/sys/accessmanagement/audit', 2)"
              >不通过</el-button
            >
            <!-- <el-button type="text" size="small">上传合同</el-button>
            <el-button type="text" size="small">上传门头照</el-button> -->
            <el-button
              v-if="
                scope.row.reviewersStatus == 2 &&
                $hasPermission('sys:accessmanagement:update')
              "
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >{{ $t("update") }}</el-button
            >
            <el-button
              v-if="
                scope.row.reviewersStatus == 1 &&
                $hasPermission('put:accessmanagement:contract')
              "
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >上传合同</el-button
            >
            <el-button
              v-if="
                scope.row.reviewersStatus == 1 &&
                $hasPermission('put:accessmanagement:door')
              "
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row.id)"
              >上传门头照</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->

      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="getDataList"
      ></add-or-update>
      <wPreview ref="preview"></wPreview>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import AddOrUpdate from "./accessmanagement-add-or-update";
import wPreview from "@/components/w-preview/index.vue";
import wUpload from "@/components/w-upload/index.vue";

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/accessmanagement/page",
        getDataListIsPage: true,
        exportURL: "/sys/accessmanagement/export",
        deleteURL: "/sys/accessmanagement",
        deleteIsBatch: true,
      },
      statusList: [
        {
          value: 0,
          label: "待审核",
        },
        {
          value: 2,
          label: "待修改",
        },
        {
          value: 1,
          label: "审核通过",
        },
      ],
      dataForm: {
        id: "",
        companyId: "",
        reviewersStatus: "",
      },
    };
  },
  methods: {
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    look(url) {
      if (!url) {
        this.$message.error("暂无url请确认是否上传文件 不支持查看");
        return;
      }
      this.$refs.preview.init(url);
    },
    
  },
  components: {
    AddOrUpdate,
    wPreview,
    wUpload,
  },
};
</script>
<style lang="scss">
.p-box p {
  cursor: pointer;
}
.showOverTooltip{
  display:-webkit-box;
  text-overflow:ellipsis;
  overflow:hidden;
    /*这里是3行*/
  -webkit-line-clamp: 3;

  -webkit-box-orient:vertical;
  
}
.content{
  max-width: 200px;
  font-size: 16px;
}






</style>
